import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import OAuthCallback from '../../pages/OAuthCallback/OAuthCallback';
import { isOAuthPopup, isOAuthReturnLocation } from '../../utils/oauthCallback';

/**
 * PrivateRoute Component
 * Protects routes that require authentication
 */

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isOAuthPopup() && isOAuthReturnLocation()) {
    return <OAuthCallback />;
  }

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh' 
      }}>
        <div>Chargement…</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;

